import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { commissionService } from '@/api/services/commissionService'

export function useVendorCommissions(p?: Parameters<typeof commissionService.vendorList>[0]) {
  return useQuery({ queryKey: ['commission', 'vendor', p], queryFn: () => commissionService.vendorList(p), staleTime: 30_000 })
}
export function useTrainerCommissions(p?: Parameters<typeof commissionService.trainerList>[0]) {
  return useQuery({ queryKey: ['commission', 'trainer', p], queryFn: () => commissionService.trainerList(p), staleTime: 30_000 })
}
export function useUpdateCommission() {
  const qc = useQueryClient()
  return useMutation({ mutationFn: (d: Record<string, unknown>) => commissionService.update(d), onSuccess: () => qc.invalidateQueries({ queryKey: ['commission'] }) })
}
